import { useEffect, useState } from "react";
import { useGetStatistics } from "./useGetStatisctics";
import { useReportsUpdateFilters } from "./useReportsUpdateFilters";

export type StatisticsData = {
  machine_name?: string | null;
  stitches?: number;
  group_name?: string | null;
  runs: number;
  total_standby_time: number;
  total_running_time: number;
  total_idle_time: number;
  thread_breaks: number;
};

export type StatisticsField =
  | "stitches"
  | "runs"
  | "thread_breaks"
  | "total_running_time"
  | "total_idle_time"
  | "total_standby_time";

export type StatisticsConfig = {
  sortBy?: StatisticsField;
  grouped?: boolean;
  amount?: number;
  fakeData?: boolean;
  startTimestamp?: Date;
  endTimestamp?: Date;
  machineGroupsFilter?: { label: string; value: string }[];
  designsFilter?: { label: string; value: string }[];
};

export const useStatistics = (config?: StatisticsConfig) => {
  const {
    startTimestamp,
    endTimestamp,
    designsFilter,
    machineGroupsFilter,
    grouped,
    fakeData,
  } = config ?? {};

  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState<boolean>();
  const reportsUpdateFilters = useReportsUpdateFilters();
  const getStatisticsData = useGetStatistics(config);
  useEffect(() => {
    const fn = async () => {
      setLoading(true);
      const data = await getStatisticsData();

      // save
      setData(data);
      setLoading(false);
    };
    fn();
  }, [
    startTimestamp,
    endTimestamp,
    designsFilter,
    machineGroupsFilter,
    grouped,
    fakeData,
  ]);

  useEffect(() => {
    if (!(config && Object.keys(config).length === 0)) {
      console.log("config to save ", JSON.stringify(config));
      reportsUpdateFilters(config, "Statistics");
    }
  }, [data]);

  return {
    data,
    loading,
  };
};
